import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { message, Modal } from "antd";
import cn from "classnames";
import { useDispatch, useSelector } from "react-redux";
import requests from "../../../../axios/requests";
import { useParams } from "react-router-dom";
import { setConfig, setRange } from "../../../../../redux/actions/actions";
import { setUser } from "../../../../../redux/actions/userActions";
import { defaultFuncAndData } from "../../../../utils/defaultData";

import Input from "../../../../components/Input/Input";
import Slider from "./Slider";
import Button from "../../../../components/Button/Button";
import variableLanguage from "../../../../utils/hooks/hookGetVariablesLanguage";
import close_modal from "../../../../../images/generate_course/close_red.svg";

const ModalBuy = ({openModalBuy, setOpenModalBuy}) => {
    const variable_11 = variableLanguage({keyPage: 'chatGptModal', keyVariable: 'variable_11'});
    const variable_14 = variableLanguage({keyPage: 'chatGptModal', keyVariable: 'variable_14'});
    const variable_15 = variableLanguage({keyPage: 'chatGptModal', keyVariable: 'variable_15'});
    const variable_19 = variableLanguage({keyPage: 'chatGptModal', keyVariable: 'variable_19'});
    const variable_20 = variableLanguage({keyPage: 'chatGptModal', keyVariable: 'variable_20'});
    const variable_21 = variableLanguage({keyPage: 'chatGptModal', keyVariable: 'variable_21'});
    const variable_22 = variableLanguage({keyPage: 'chatGptModal', keyVariable: 'variable_22'});
    const variable_23 = variableLanguage({keyPage: 'chatGptModal', keyVariable: 'variable_23'});
    const variable_24 = variableLanguage({keyPage: 'chatGptModal', keyVariable: 'variable_24'});

    const {user, language, activeTheme: activeThemeFromRedux} = useSelector(state => state.Reducer);
    const activeTheme = activeThemeFromRedux ?? (localStorage.getItem("activeTheme") === "true");
    const dispatch = useDispatch();
    const params = useParams();
    const {range, config} = useSelector(state => state.SliderReducer);
    const [price, setPrice] = useState(null);

    const buyTries = useCallback(() => {
        requests.users.buy_education_plan(range >= 5 ? range : 5)
            .then(res => {
                setTimeout(() => window.location.href = res.data.payment_url);
            })
            .catch(() => {});
    }, [range]);

    const { discount, result } = useMemo(() => {
        let discountVal = 0;
        for (let i = 5; i < range; i++) discountVal += 0.01;
        const discountPercent = Number((discountVal * 100).toFixed(2));
        const resultVal = price != null ? (1 - discountVal) * (Number(price) * range) : null;
        return { discount: discountPercent, result: resultVal };
    }, [range, price]);

    useEffect(() => {
        if (params?.token) {
            localStorage.setItem("token", params.token);
        }
    }, [params?.token]);

    useEffect(() => {
        Promise.all([
            requests.users.get_config()
                .then(res => {
                    dispatch(setConfig(res.data));
                    setPrice(res.data.PLAN_TEACHER_RATE);
                })
                .catch(() => {}),
            params?.token ? requests.users.get_profile_new().then(res => dispatch(setUser(res.data))) : Promise.resolve()
        ]);
    }, [dispatch, params?.token]);
    return (
        <>
            {params?.token &&
                <div className="text count">
                    {language === "ru"
                        ? <>
                            {defaultFuncAndData.declension(user?.education_plan_limit, ["Доступна ", "Доступны ", "Доступны "])}
                            {user?.education_plan_limit}
                            {defaultFuncAndData.declension(user?.education_plan_limit, [" генерация курса", " генерации курса", " генераций курсов"])}
                        </>
                        : <>
                            {variable_20}
                            {user?.education_plan_limit}
                            {variable_21}
                        </>
                    }
                </div>
            }
            <Modal
                open={params?.token ? true : openModalBuy}
                footer={null}
                className={cn("buy_education", { "theme-white": activeTheme })}
                wrapClassName={cn("buy_education", { "theme-white": activeTheme })}
                style={activeTheme ? { backgroundColor: "#FFFFFF" } : { backgroundColor: "#201E26" }}
                closable={false}
                onCancel={() => {
                    if (!params?.token) { // закрыть модальное если это не web vue
                        setOpenModalBuy(false)
                    }
                }}
                maskStyle={{backgroundColor: "transparent"}}
                bodyStyle={{
                    padding: "30px",
                    borderRadius: 40,
                    backgroundColor: activeTheme ? "#FFFFFF" : "#201E26"
                }}
                destroyOnClose={true}
            >
                <div className="title">
                    {variable_19}
                    {!params?.token &&
                        <div
                            className="close"
                            onClick={() => {
                                if (!params?.token) { // закрыть модальное если это не web vue
                                    setOpenModalBuy(false)
                                }
                            }}
                        >
                            <img src={close_modal} alt="close_modal"/>
                        </div>
                    }
                </div>
                <div className="main">
                    <div className="price_row">
                        <div className="label">{variable_22}</div>
                        <div className="value">{price != null ? range * price : "—"}₽</div>
                    </div>
                    <div className="price_row">
                        <div className="label">{variable_23} {discount}%: </div>
                        <div className="value green">{result != null ? result.toFixed(0) : "—"}₽</div>
                    </div>
                </div>
                <div className="slider_row">
                    <Slider/>
                    <Input
                        padding={"4px 0 5px"}
                        margin={"0 0 0 5px"}
                        value={range}
                        maxWidth={"50px"}
                        setValue={(value) => {
                            dispatch(setRange(value > 50 ? 50 : value));
                        }}
                        backgroundColor={activeTheme ? "#F1F5F9" : "var(--background_lighten-dark)"}
                        onBlur={() => {
                            if (range < 5) {
                                dispatch(setRange(5));
                                message.error(variable_24);
                            }
                        }}
                        textAlign={true}
                        min={5}
                        max={50}
                        type={"number"}
                    />
                </div>

                <Button
                    text={variable_11}
                    click={() => buyTries()}
                    margin={"30px 0 0 0"}
                    maxWidth={"100%"}
                    zIndex={1}
                />

            </Modal>
        </>
    );
};

export default ModalBuy;